import * as React from 'react';
import { HeatingZoneID } from '../../../shared/api-clients/_api';
import { ISelectZoneProps, SelectZone } from './select-zone';

export const SelectInstallLocation: React.FunctionComponent<ISelectZoneProps> = props => {
  return (
    <SelectZone
      optionLabel={'Select an install location'}
      data-qa="select-install-location"
      {...props}
      filterOptions={[HeatingZoneID.WHOLE_HOME, ...(props.filterOptions ?? [])]}
    />
  );
};
